module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container teachers"
  }, [_c('com-title', {
    attrs: {
      "title": "企业赋能顾问"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "parentBox"
  }, [_c('ul', {
    staticClass: "columns is-mobile"
  }, _vm._l((_vm.teachers), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "column is-one-third-tablet is-one-quarter-desktop"
    }, [_c('div', {
      staticClass: "wrap"
    }, [_c('a', {
      attrs: {
        "herf": "javascript:void(0)"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "brief"
    }, [_vm._v(_vm._s(item.company) + "，" + _vm._s(item.brief)), _c('br'), _c('br'), _vm._v(_vm._s(item.focus))])])])])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("更多技术专家讲师资源请垂询企业培训服务顾问")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b76d17c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/consultation/com-tea.vue
// module id = 458
// module chunks = 1